/** 権限フラグタイプ */
export enum PermissionType {
	/** 管理権限 */
	Admin = 0,
	/** 個人情報権限 */
	PersonalInfo = 1,
	/** 予約権限 */
	Reservation = 2,
}